var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"application-badge",style:({ borderColor: _vm.color })},[_c('abbr',{style:([{ color: _vm.color }]),attrs:{"title":_vm.title,"aria-label":_vm.title}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.abbr))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }